import {
  useOutlookDisconnect,
  useOutlookRedirectUrl,
} from '@/hooks/actions/use-email-integration-actions';
import type { EmailMetadata } from '@fluenceur/types';
import EmailIntegration, { type EmailIntegrationConfig } from './EmailIntegration';
import type { IntegrationCardVariant } from './IntegrationCard';

const OUTLOOK_CONFIG: EmailIntegrationConfig = {
  i18nPrefix: 'integrations.outlook',
  callbackParam: 'outlook',
  icon: '/images/integrations/outlook.svg',
};

interface OutlookIntegrationProps {
  id: string | null;
  isConnected: boolean;
  needsRefresh?: boolean;
  senderEmail?: string;
  metadata?: EmailMetadata;
  variant?: IntegrationCardVariant;
  detailHref?: string;
}

const OutlookIntegration = (props: OutlookIntegrationProps) => (
  <EmailIntegration
    {...props}
    config={OUTLOOK_CONFIG}
    redirectMutation={useOutlookRedirectUrl()}
    disconnectMutation={useOutlookDisconnect()}
  />
);

export default OutlookIntegration;
